import { Paper } from '@mui/material';

export const FixedFooter = ({ children }) => {
  return (
    <Paper
      square
      sx={{
        backgroundColor: 'rgba(241,244,245,0.9)',
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1299,
        backdropFilter: 'blur(2px)',
        boxShadow:
          '0px 0px 50px -20px rgb(0 0 0 / 90%), 0 0 3px rgb(0 0 0 / 10%), 0px 0px 35px -23px rgb(0 0 0 / 91%), 0px 15px 35px -10px rgb(0 0 0 / 91%) !important',
      }}
    >
      {children}
    </Paper>
  );
};
